function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_777",
  "data-name": "Group 777",
  transform: "translate(-121 -215)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(121 215)"
}, React.createElement("path", {
  id: "Icon.BG",
  d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0Z",
  fill: "rgba(56,222,252,0.16)"
})), React.createElement("g", {
  id: "Page-1",
  transform: "translate(130.4 224.5)"
}, React.createElement("g", {
  id: "user",
  transform: "translate(0.6 0.5)"
}, React.createElement("path", {
  id: "Shape",
  d: "M33.518,10.121A4.81,4.81,0,1,0,28.7,5.3,4.819,4.819,0,0,0,33.518,10.121Zm0-8.365A3.547,3.547,0,1,1,29.971,5.3,3.557,3.557,0,0,1,33.518,1.756Z",
  transform: "translate(-24.547 -0.5)",
  fill: "#09b0ee"
}), React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M1.235,77.98H17.965a.631.631,0,0,0,.635-.635A6.052,6.052,0,0,0,12.556,71.3H6.644A6.052,6.052,0,0,0,.6,77.344.631.631,0,0,0,1.235,77.98Zm5.409-5.409h5.911a4.77,4.77,0,0,1,4.729,4.138H1.915A4.783,4.783,0,0,1,6.644,72.571Z",
  transform: "translate(-0.6 -60.837)",
  fill: "#09b0ee"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/support-icon.5895e965.svg";
export { SvgComponent as ReactComponent };